import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TextField } from '@material-ui/core';
import clsx from 'clsx';
import { loginUserAction } from '../../../modules/auth/Actions';
import { authIsLoadingSelector } from '../../../modules/auth/Selectors';
import { CheckBox } from '../../../components/form';
import getLangData from '../../../utils/getLangData';

function Login(props) {
  const { intl, loginUser, authIsLoading, loginUserOnRemember } = props;
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: '2.5rem'
  });

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: '3.5rem' });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: '2.5rem' });
  };

  return (
    <>
      <div className='kt-login__body'>
        <div className='kt-login__form'>
          <div className='kt-login__title'>
            <h3>
              {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
              {getLangData().login.title}
            </h3>
          </div>

          <Formik
            initialValues={{
              email: '',
              password: '',
              rememberMe: false
            }}
            onSubmit={async values => {
              const expiretionDate = values.rememberMe ? 90 : 7;
              loginUser(values, expiretionDate);
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form className='kt-form' onSubmit={handleSubmit}>
                {status ? (
                  <div role='alert' className='alert alert-danger'>
                    <div className='alert-text'>{status}</div>
                  </div>
                ) : null}

                <div className='form-group'>
                  <TextField
                    label={getLangData().fields.email}
                    margin='normal'
                    className='kt-width-full'
                    name='email'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    helperText={touched.email && errors.email}
                    error={Boolean(touched.email && errors.email)}
                  />
                </div>
                <div className='form-group'>
                  <TextField
                    type='password'
                    margin='normal'
                    label={getLangData().fields.password}
                    className='kt-width-full'
                    name='password'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>
                <div>
                  <CheckBox
                    name='rememberMe'
                    label={getLangData().login.remember_me}
                  />
                </div>

                <div className='kt-login__actions'>
                  <Link
                    to='/auth/forgot-password'
                    className='kt-link kt-login__link-forgot'
                  >
                    {getLangData().login.forget_password}
                  </Link>

                  <button
                    id='kt_login_signin_submit'
                    type='submit'
                    disabled={authIsLoading}
                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                      {
                        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': authIsLoading
                      }
                    )}`}
                    style={loadingButtonStyle}
                  >
                    {getLangData().login.sign_in}
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  authIsLoading: authIsLoadingSelector(state)
});

export default injectIntl(
  connect(mapStateToProps, {
    loginUser: loginUserAction
  })(Login)
);
